module.exports = "/packs/005-32b593a24cffe16bf7144578e896a7b0.jpg";